import { useMutation } from "./urqlHooks";


const FIND_COMPANY_NAME = `mutation FIND_COMPANYNAME($rut: String!){
    findCompanyName(rut: $rut)
}`;

export const FindCompanyName = () => {
    const [result, executeMutation] = useMutation(FIND_COMPANY_NAME)
    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation }
};